import {getClassQuery} from './get-class'
import {getVenueClassesQuery} from './get-venue-classes'

export const ClassQueries = {
  getClassQuery,
  getVenueClassesQuery,
}
